export const PROFILE = {
  DEV: 'dev',
  PROD: 'prod',
};